import { createHTTPActions } from '../utils';
import { IAccountScorecards } from '../../../feature-modules/insights/pages/manage-scorecards/models/scorecard.model';

export enum EScorecardsActions {
  getScorecards = '[Scorecards] Get Scorecards',
  cleanScorecards = '[Scorecards] Clean Scorecards',
}

const [getScorecards, getScorecardsSuccess, getScorecardsError] = createHTTPActions<
  number[],
  IAccountScorecards[],
  Error
>(EScorecardsActions.getScorecards);

const [cleanScorecards] = createHTTPActions<void>(EScorecardsActions.cleanScorecards);

export const SCORECARDS_ACTIONS = {
  getScorecards,
  getScorecardsSuccess,
  getScorecardsError,
  cleanScorecards,
};
